export const ARROW_DESIGN_TYPE = {
    ARROWS_ON_BOTTOM_MIDDLE: "arrows-on-bottom-middle",
    ARROWS_ON_TOP_RIGHT: "arrows-on-top-right"
};
